<kui-alert-panel [message]="errorMessage">
    @if (allowRetry) {
        <button kui-button (click)="initializeFeed()" class="ml-auto" color="primary">
            <kui-icon name="sync" class="pr-1"></kui-icon>
            {{ "DIALOG.RETRY" | translate }}
        </button>
    }
</kui-alert-panel>

@if (!errorMessage) {
    <div class="feed">
        @if ((!sectionList || !sectionList.length) && !loading && !errorMessage) {
            <kui-alert type="none" class="m-1 d-block key-alert-wrapper bordered">
                <kui-icon name="info-circle" size="sm"></kui-icon>
                <span>{{ "SHARED.FEED.NO_RECENT." + type.toUpperCase() | translate }}</span>
            </kui-alert>
        }
        @for (section of sectionList; track section) {
            <div>
                @if (hasValidItems(section)) {
                    <h5 class="feed-title">{{ section.title }}</h5>
                    @for (item of section.items; track item) {
                        @if (filterItemBy ? filterItemBy(item) : true) {
                            @switch (type) {
                                @case ("trip") {
                                    <key-trip-feed-item
                                        class="feed-item-trip"
                                        [data]="item"
                                        (primaryActionClicked)="clickPrimaryAction(item)"
                                        [actions]="getItemActions(item)"
                                        [class.selected]="item.id === selectedItem?.id"
                                    ></key-trip-feed-item>
                                }
                                @case ("event") {
                                    <key-event-feed-item
                                        [titleType]="item && item['alerts'] && item['alerts'].length ? 'alert' : 'event'"
                                        [dateField]="dateField"
                                        class="feed-item-event"
                                        [data]="item"
                                        (primaryActionClicked)="clickPrimaryAction(item)"
                                        [actions]="getItemActions(item)"
                                        [class.selected]="item.id === selectedItem?.id"
                                    ></key-event-feed-item>
                                }
                                @case ("alert") {
                                    <key-event-feed-item
                                        class="feed-item-alert"
                                        [data]="item"
                                        [dateField]="dateField"
                                        (primaryActionClicked)="clickPrimaryAction(item)"
                                        [actions]="getItemActions(item)"
                                        [class.selected]="item.id === selectedItem?.id"
                                        titleType="alert"
                                    ></key-event-feed-item>
                                }
                                @case ("audit") {
                                    <key-audit-feed-item
                                        class="feed-item-event"
                                        [data]="item"
                                        (primaryActionClicked)="clickPrimaryAction(item)"
                                        [actions]="getItemActions(item)"
                                        [class.selected]="item.id === selectedItem?.id"
                                    ></key-audit-feed-item>
                                }
                                @case ("log") {
                                    <key-log-feed-item
                                        class="feed-item-event"
                                        [data]="item"
                                        (primaryActionClicked)="clickPrimaryAction(item)"
                                        [actions]="getItemActions(item)"
                                        [class.selected]="item.id === selectedItem?.id"
                                    ></key-log-feed-item>
                                }
                                @case ("notification") {
                                    <key-notification-feed-item
                                        class="feed-item-event"
                                        [data]="item"
                                        (primaryActionClicked)="clickPrimaryAction(item)"
                                        [actions]="getItemActions(item)"
                                        [class.selected]="item.id === selectedItem?.id"
                                    ></key-notification-feed-item>
                                }
                            }
                        }
                    }
                }
            </div>
        }
        @if (loading) {
            <div class="feed-footer p-3">
                <kui-loader size="small"></kui-loader>
            </div>
        }
        @if (!loading && hasMore) {
            <div class="feed-footer p-3">
                <a (click)="loadMore()" kui-action class="text-link">{{ "SHARED.FEED.SHOW_MORE" | translate }}</a>
            </div>
        }
        <div class="feed-footer p-1" key-intersection-observer (intersecting)="loadMoreRequest($event)"></div>
    </div>
}
